import useTranslation from '../../../../../shared/hooks/useTranslation';
import cn from '../../../../../shared/utils/classNames';

import type { HelpSection } from '../helpContent';

import styles from '../HelpMenuButton.module.css';

interface HelpSectionViewProps {
  section: HelpSection;
  hideHeading?: boolean;
  fullWidth?: boolean;
  onDarkBackground?: boolean;
  compact?: boolean;
}

const HelpSectionView = ({
  section,
  hideHeading = false,
  fullWidth = false,
  onDarkBackground = false,
  compact = false,
}: HelpSectionViewProps) => {
  const { t } = useTranslation();

  return (
    <article className={cn(
      styles.sectionArticle,
      fullWidth && styles.sectionArticleFull,
      compact && styles.sectionArticleCompact,
    )}>
      {!hideHeading && (
        <h2 className={styles.sectionHeading}>{section.title}</h2>
      )}
      <p
        className={cn(
          styles.sectionIntro,
          onDarkBackground && styles.sectionIntroOnDark,
          compact && styles.sectionIntroCompact,
        )}
      >
        {section.intro}
      </p>

      <div className={cn(styles.blocks, compact && styles.blocksCompact)}>
        {section.blocks.map((block) => (
          <section key={block.title} className={cn(styles.block, compact && styles.blockCompact)}>
            <h3 className={cn(styles.blockTitle, compact && styles.blockTitleCompact)}>{block.title}</h3>

            {block.text && (
              <p className={styles.blockText}>{block.text}</p>
            )}

            {block.items && block.items.length > 0 && (
              <ul className={cn(styles.blockList, compact && styles.blockListCompact)}>
                {block.items.map((item) => (
                  <li key={item} className={cn(styles.blockListItem, compact && styles.blockListItemCompact)}>{item}</li>
                ))}
              </ul>
            )}

            {block.where && (
              <p className={styles.whereCallout}>
                <span className={styles.whereLabel}>{t('help.whereLabel')}:</span>
                {block.where}
              </p>
            )}

            {block.tip && (
              <p className={cn(styles.tipCallout, compact && styles.tipCalloutCompact)}>
                <span className={styles.tipLabel}>{t('help.tipLabel')}:</span>
                {block.tip}
              </p>
            )}
          </section>
        ))}
      </div>
    </article>
  );
};

export default HelpSectionView;
